import specVideo from "../../../../content/blog/posts/jetpack-compose-collapsible-extended-floating-action-button/m3-collapsible-fab-behavior.mp4";
import * as React from 'react';
export default {
  specVideo,
  React
};